var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { checkFunction } from "../check/checkFunction.js";
import { checkNodeParameters } from "../check/checkNodeParameters.js";
import { checkRule } from "../check/checkRule.js";
import { checkTypeParameters } from "../check/checkTypeParameters.js";
import { defineLocals } from "../env/defineLocals.js";
import { appendReport } from "../errors/index.js";
import { evaluate, evaluateOne, evaluateParameters, } from "../evaluate/index.js";
import { importAll } from "../import/importAll.js";
import { importMany } from "../import/importMany.js";
import { define, defineRule } from "../mod/index.js";
import {} from "../stmt/index.js";
export function execute(mod, stmt) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const options = { checking: mod.checking };
            switch (stmt["@kind"]) {
                case "DefineNode": {
                    const input = evaluateParameters(mod, mod.env, stmt.input, options);
                    const output = evaluateParameters(mod, mod.env, stmt.output, options);
                    checkNodeParameters(mod, input, output);
                    define(mod, stmt.name, {
                        "@type": "Definition",
                        "@kind": "NodeDefinition",
                        mod,
                        name: stmt.name,
                        input,
                        output,
                        span: stmt.span,
                    });
                    return null;
                }
                case "DefineType": {
                    const input = evaluateParameters(mod, mod.env, stmt.input, options);
                    checkTypeParameters(mod, input);
                    define(mod, stmt.name, {
                        "@type": "Definition",
                        "@kind": "TypeDefinition",
                        mod,
                        name: stmt.name,
                        input,
                        span: stmt.span,
                    });
                    return null;
                }
                case "DefineFunction": {
                    const input = evaluateParameters(mod, mod.env, stmt.input, options);
                    const retType = evaluateOne(mod, mod.env, stmt.retType, options);
                    checkFunction(mod, input, retType, stmt.body);
                    define(mod, stmt.name, {
                        "@type": "Definition",
                        "@kind": "FunctionDefinition",
                        mod,
                        name: stmt.name,
                        input,
                        retType,
                        body: stmt.body,
                        span: stmt.span,
                    });
                    return null;
                }
                case "DefineRule": {
                    checkRule(mod, stmt.first, stmt.second, stmt.body);
                    defineRule(mod, stmt.first, stmt.second, stmt.body);
                    return null;
                }
                case "TopLevelEvaluate": {
                    const values = evaluate(mod, mod.env, stmt.exp, options);
                    mod.env.stack.push(...values);
                    return null;
                }
                case "TopLevelLet": {
                    const values = evaluate(mod, mod.env, stmt.exp, options);
                    defineLocals(mod.env, stmt.names, values);
                    return null;
                }
                case "Require": {
                    const url = new URL(stmt.path, mod.url);
                    const fetcher = mod.loader.fetcher;
                    if (mod.loader.loading.has(url.href)) {
                        throw new Error([
                            `[execute / Require] I can not do circular require.`,
                            ``,
                            `  loading module url: ${fetcher.formatURL(mod.url)}`,
                            `  requiring module url: ${fetcher.formatURL(url)}`,
                        ].join("\n"));
                    }
                    if (mod.requiredMods.get(url.href))
                        return null;
                    const loadedMod = yield mod.loader.load(url);
                    importAll(mod, loadedMod);
                    for (const [key, requiredMod] of loadedMod.requiredMods) {
                        mod.requiredMods.set(key, requiredMod);
                    }
                    mod.requiredMods.set(url.href, loadedMod);
                    return null;
                }
                case "Import": {
                    const url = new URL(stmt.path, mod.url);
                    const fetcher = mod.loader.fetcher;
                    if (mod.loader.loading.has(url.href)) {
                        throw new Error([
                            `[execute / Import] I can not do circular import.`,
                            ``,
                            `  loading module url: ${fetcher.formatURL(mod.url)}`,
                            `  importing module url: ${fetcher.formatURL(url)}`,
                        ].join("\n"));
                    }
                    const loadedMod = yield mod.loader.load(url);
                    importMany(mod, loadedMod, stmt.bindings);
                    return null;
                }
            }
        }
        catch (error) {
            throw appendReport(error, {
                message: [`[execute] I fail to execute a statement.`].join("\n"),
                context: {
                    span: stmt.span,
                    text: mod.text,
                },
            });
        }
    });
}
//# sourceMappingURL=execute.js.map